import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import "scss/global.scss"

class Footer extends React.Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query SocialIconsQuery {
            allFile(
              filter: {
                sourceInstanceName: { eq: "images" }
                relativePath: {
                  in: [
                    "footer/x.png"
                    "footer/facebook.png"
                    "footer/instagram.png"
                    "footer/youtube.png"
                    "footer/linkedin.png"
                    "footer/teams.png"
                    "footer/whatsapp.png"
                  ]
                }
              }
            ) {
              nodes {
                relativePath
                childImageSharp {
                  gatsbyImageData(layout: FIXED, width: 25, height: 25)
                }
              }
            }
          }
        `}
        render={(data) => {
          // Mapear relativePath a gatsbyImageData
          const iconMap = {}
          data.allFile.nodes.forEach((node) => {
            const key = node.relativePath.replace("footer/", "")
            iconMap[key] = getImage(node.childImageSharp.gatsbyImageData)
            console.log(`Found icon: ${key}`)
          })

          const socialLinks = [
            {
              name: "x.png",
              url: "https://x.com/VASCOSOLUTIONS",
              alt: "X de VASCO Solutions",
            },
            {
              name: "facebook.png",
              url: "https://facebook.com/VASCOSOLUTIONS",
              alt: "Facebook de VASCO Solutions",
            },
            {
              name: "instagram.png",
              url: "https://instagram.com/vascosolutions/",
              alt: "Instagram de VASCO Solutions",
            },
            {
              name: "youtube.png",
              url: "https://www.youtube.com/user/VASCOSolutions/videos",
              alt: "YouTube de VASCO Solutions",
            },
            {
              name: "linkedin.png",
              url: "https://www.linkedin.com/company/vasco-solutions-ltda-?trk=ppro_cprof",
              alt: "LinkedIn de VASCO Solutions",
            },
            {
              name: "teams.png",
              url: "https://teams.microsoft.com/l/chat/0/0?users=vasco_solutions",
              alt: "Microsoft Teams de VASCO Solutions",
            },
            {
              name: "whatsapp.png",
              url: "https://api.whatsapp.com/send?phone=573102767675",
              alt: "WhatsApp de VASCO Solutions",
              onClick: () => {
                window.gtag("event", "click_button_whatsapp", {
                  button_name: "WhatsApp",
                  destination_url:
                    "https://api.whatsapp.com/send?phone=573102767675",
                })
              },
            },
          ]

          return (
            <div className="footer-main">
              <div className="social-icons">
                {socialLinks.map((link) => {
                  if (!iconMap[link.name]) {
                    console.warn(`Icon not found: ${link.name}`)
                    return null
                  }
                  return (
                    <a
                      key={link.name}
                      href={link.url}
                      target="_blank"
                      rel="nofollow noreferrer"
                      onClick={link.onClick}
                    >
                      <GatsbyImage
                        image={iconMap[link.name]}
                        alt={link.alt}
                        className="social_icon"
                        loading="lazy"
                      />
                    </a>
                  )
                })}
              </div>
            </div>
          )
        }}
      />
    )
  }
}

export default Footer
